(function () {
  /* Lazy-Videos: <video data-sob-lazy> lädt Quellen erst kurz bevor es sichtbar wird, pausiert außerhalb */
  var lazyVideos = document.querySelectorAll('video[data-sob-lazy]');
  if (lazyVideos.length && 'IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          if (!v.dataset.sobLoaded) {
            v.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.dataset.src; });
            v.load();
            v.dataset.sobLoaded = '1';
          }
          var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
        } else if (v.dataset.sobLoaded) {
          v.pause();
        }
      });
    }, { rootMargin: '300px 0px' });
    lazyVideos.forEach(function (v) { vio.observe(v); });
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isFinePointer = window.matchMedia('(pointer: fine)').matches;

  /* Produktraster: Einblenden pro Reihe links -> Mitte -> rechts (Verzögerung nach Spalte statt nach laufender Nummer) */
  function sobStaggerByColumn() {
    document.querySelectorAll('.product-grid').forEach(function (grid) {
      var items = Array.prototype.slice.call(grid.children);
      var lefts = [];
      items.forEach(function (li) {
        var l = Math.round(li.offsetLeft);
        if (lefts.indexOf(l) === -1) lefts.push(l);
      });
      lefts.sort(function (a, b) { return a - b; });
      items.forEach(function (li) {
        var col = lefts.indexOf(Math.round(li.offsetLeft));
        li.style.setProperty('--animation-order', col * 4); // 4 x 75 ms = 300 ms pro Spalte
        li.style.transitionDelay = col * 300 + 'ms';
      });
    });
  }
  sobStaggerByColumn();
  var sobResizeT;
  window.addEventListener('resize', function () {
    clearTimeout(sobResizeT);
    sobResizeT = setTimeout(sobStaggerByColumn, 200);
  });

  /* Scroll-Reveal für Text- und Produktkarten */
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var revealEls = document.querySelectorAll(
      '.rich-text__heading, .rich-text__text, .rich-text__buttons, .product-grid > li, .collection-list__item, .card-wrapper, .sob-reveal'
    );
    if (revealEls.length) {
      revealEls = Array.prototype.filter.call(revealEls, function (el) {
        /* Nicht doppelt animieren, wenn Dawn das Element schon per Scroll-Trigger einblendet */
        return !el.closest('.scroll-trigger');
      });
      revealEls.forEach(function (el, i) {
        el.classList.add('sob-reveal');
        el.addEventListener('transitionend', function () { el.classList.add('sob-reveal--done'); }, { once: true });
        if (!el.style.transitionDelay) {
          el.style.transitionDelay = Math.min(i % 4, 3) * 90 + 'ms';
        }
      });
      var revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );
      revealEls.forEach(function (el) {
        revealObserver.observe(el);
      });
    }
  }

  if (!isFinePointer) return;

  /* Produktvideo beim Hover über eine Produktkachel (lädt erst beim ersten Hover) */
  document.querySelectorAll('[data-sob-card-video]').forEach(function (v) {
    var card = v.closest('.card-wrapper') || v.closest('.card');
    if (!card) return;
    card.addEventListener('mouseenter', function () {
      if (!v.src) v.src = v.getAttribute('data-sob-card-video');
      v.currentTime = 0;
      var p = v.play();
      if (p && p.then) p.then(function () { v.classList.add('is-playing'); }).catch(function () {});
    });
    card.addEventListener('mouseleave', function () {
      v.classList.remove('is-playing');
      v.pause();
    });
  });

  /* Magnetischer Effekt für den Haupt-CTA */
  var magneticEls = document.querySelectorAll('.sob-hero__button');
  magneticEls.forEach(function (el) {
    el.addEventListener('mousemove', function (e) {
      var rect = el.getBoundingClientRect();
      var x = e.clientX - rect.left - rect.width / 2;
      var y = e.clientY - rect.top - rect.height / 2;
      el.style.transform = 'translate(' + x * 0.25 + 'px, ' + y * 0.35 + 'px)';
    });
    el.addEventListener('mouseleave', function () {
      el.style.transform = '';
    });
  });

  if (reduceMotion) return;

  /* Film-Grain-Overlay entfernt (19.10.2026): vollflächiges, animiertes Blend-Layer kostete beim Scrollen jeden Frame Neuzeichnen */
})();
